const MIN_WIDTH_IN_PERCENTS: number = 40;

const MAX_WIDTH_IN_PERCENTS: number = 100;

export { MIN_WIDTH_IN_PERCENTS, MAX_WIDTH_IN_PERCENTS };
